export const useIsTouchDevice = () => {
  const isTouchable =
    window.matchMedia('(hover: none)').matches ||
    window.matchMedia('(pointer: coarse)').matches ||
    'ontouchstart' in window ||
    false;

  const isIosOrAndroid = /Android|iPhone/i.test(navigator.userAgent);

  return {
    isTouch: isTouchable, // Any device that supports touch
    isMobileDevice: isIosOrAndroid, // iOS or Android? It's a mobile device
    isTouchDevice: isIosOrAndroid && isTouchable, // A physical iOS or Android device or simulator
  };
};
